import { React, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Button, Icon, Modal } from "semantic-ui-react";
import { map, isEmpty, reject, orderBy } from "lodash";

// Redux
import { connect } from "react-redux";
import genericAction from "@Actions/generic";

// Components
import IkTable from "@Components/IkTable";

// staticData
import ConfirmModal from "@Modals/ConfirmModal";
import dataHandler from "@Utils/dataHandler";

// Styles
import styles from "./styles.module.css";

const ContactFilter = ({ onClose, dispatch, apiData, contactLinkMode }) => {
	ContactFilter.propTypes = {
		dispatch: PropTypes.object,
		apiData: PropTypes.func,
		onClose: PropTypes.func,
		contactLinkMode: PropTypes.string,
	};
	const [filteredCount, setfilteredCount] = useState(null);
	// hooks
	const [openConfirmModal, setOpenConfirmModal] = useState(false);
	const [tableValue, setTableValue] = useState({});
	const [checkAllData, setCheckAllData] = useState([]);
	const [filteredItems, setFilteredItems] = useState([]);

	// Effects
	const defaultParams =
		contactLinkMode === "link"
			? { page: 1, orderKey: "contactId", orderDir: "desc" }
			: {
					page: 1,
					orderKey: "contactId",
					"contactSharedId!": null,
					orderDir: "desc",
			  };

	useEffect(() => {
		(async () => {
			const contactPromise = await dataHandler({
				dispatch,
				url: "contacts",
				params: defaultParams,
			});

			const [contactResponse] = await Promise.all([contactPromise]);
			setfilteredCount(contactResponse.count);
			setFilteredItems(contactResponse.items);
		})();
	}, [contactLinkMode]);

	const handlerTable = (name, item) => {
		if (name === "Eraser") {
			setFilteredItems(reject(filteredItems, { id: item.id }));
		}
	};

	const handlerMultiple = (selectedItems) => {
		setTableValue(selectedItems);
	};

	// save handlers
	const save = async () => {
		const contactIds = map(tableValue, (item) => {
			return item.id;
		});

		const contactSharedId = orderBy(
			map(tableValue, (item) => {
				return item.contactSharedId;
			}),
			[],
			"asc"
		);
		switch (contactLinkMode) {
			case "link": {
				await dispatch(
					genericAction({
						method: "post",
						route: `contacts/link`,
						body: {
							contactIds: isEmpty(contactIds) ? null : contactIds,
							contactSharedId: contactSharedId[0],
						},
					})
				);
				apiData("link");
				break;
			}
			case "unlink": {
				await dispatch(
					genericAction({
						method: "post",
						route: `contacts/unlink`,
						body: {
							contactIds: isEmpty(contactIds) ? null : contactIds,
							contactSharedId: contactSharedId[0],
						},
					})
				);
				apiData("unlink");

				break;
			}
			default:
				break;
		}

		setOpenConfirmModal(false);
	};

	const handlerData = async (params, printable, findAll) => {
		const data = await dataHandler({
			dispatch,
			url: "contacts",
			params: { ...params, contactSharedId: null },
		});

		if (printable) {
			return null;
		}

		if (findAll) {
			setCheckAllData(data.items);
		} else {
			setFilteredItems(data.items);
			setfilteredCount(data.count);
		}

		return null;
	};

	return (
		<div>
			<Modal centered={false} open closeIcon className={styles.modal} onClose={onClose}>
				<Modal.Header className={styles.modalHeader}>
					{contactLinkMode === "link" && <Icon name="linkify" />}
					{contactLinkMode === "unlink" && <Icon name="unlink" />}
					{contactLinkMode === "link" && "Enlazar Contactos"}
					{contactLinkMode === "unlink" && "Desenlazar Contactos"}
				</Modal.Header>

				<Modal.Content className={styles.modalContent} scrolling>
					<IkTable
						data={filteredItems}
						columns={[
							{
								label: "Acción",
								action: [{ content: "trash", color: "#b43333", onClick: "Eraser", type: "icon" }],
								dataPosition: "center",
								width: 1,
								hidden: contactLinkMode === "unlink",
							},
							{
								multiple: true,
								key: "contactId",
								dataPosition: "center",
							},
							{
								label: "ID",
								key: "contactId",
								format: "string",
								dataPosition: "center",

								width: 1,
							},
							{
								label: "Nombre",
								key: "name",
								format: "string",
								width: 6,
								canFilter: true,
								canSort: true,
								canPrint: true,
								canExcel: true,
								sortKey: null,
							},
							{
								label: "ID Enlace",
								key: "contactSharedId",
								format: "string",
								dataPosition: "center",
								width: 4,
								canFilter: true,
								canSort: true,
								canPrint: true,
								canExcel: true,
								sortKey: null,
							},
							{
								label: "Canal",
								key: "contact.channel",
								format: "string",
								dataPosition: "center",
								width: 4,
								canFilter: true,
								canSort: true,
								canPrint: true,
								canExcel: true,
								sortKey: null,
							},
						]}
						totalRows={filteredCount}
						handlerMultiple={handlerMultiple}
						checkAllData={checkAllData}
						defaultParams={defaultParams}
						dataHandler={handlerData}
						searcher={{ width: "40rem" }}
						handlerTable={handlerTable}
					/>
				</Modal.Content>

				<Modal.Actions className={styles.modalAction}>
					<Button className={styles.negativeButton} onClick={onClose}>
						Cerrar
					</Button>

					<Button
						disabled={tableValue.length < 2}
						className={styles.positiveButton}
						onClick={() => {
							return setOpenConfirmModal(true);
						}}>
						{contactLinkMode === "link" && "Enlazar"}
						{contactLinkMode === "unlink" && "Desenlazar"}
					</Button>
				</Modal.Actions>
			</Modal>
			{openConfirmModal && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					header="Confirmar"
					content={
						contactLinkMode === "unlink"
							? "Está seguro que desea desenlazar los contactos seleccionados"
							: "Está seguro que desea enlazar los contactos seleccionados"
					}
					onConfirm={() => {
						return save();
					}}
					onDismiss={() => {
						return setOpenConfirmModal(false);
					}}
				/>
			)}
		</div>
	);
};

function mapStateToProps({ user, company }) {
	return {
		companyName: company.name,
		userName: user.name,
	};
}

export default connect(mapStateToProps)(ContactFilter);
